import React from 'react';
import { Link } from 'react-router-dom';
export function NotFound() {
  return <section className="mx-auto flex max-w-7xl flex-col items-start px-5 py-28 lg:px-8" data-id="element-640" data-mp="w3zsnkrmzrwf">
      <p className="text-sm font-medium text-primary" data-id="element-641" data-mp="105uucqdhc7aq">Pagina niet gevonden</p>
      <h1 className="mt-3 font-display text-4xl font-semibold tracking-tight text-ink sm:text-5xl" data-id="element-642" data-mp="107z6fvlj8cm3">
        Deze pagina bestaat niet (meer)
      </h1>
      <p className="mt-4 max-w-lg text-lg text-muted" data-id="element-643" data-mp="1a4u286qf7ywo">Misschien is de pagina verplaatst. Ga terug naar de homepage of bekijk onze pijnklachten.</p>
      <div className="mt-8 flex gap-3" data-id="element-644" data-mp="1f110ddcks642">
        <Link to="/" className="rounded-full bg-primary px-6 py-3 text-[15px] font-semibold text-white hover:bg-primary-dark" data-id="element-645" data-mp="1jtc1gjj1xxy7">
          Naar home
        </Link>
        <Link to="/pijnklachten" className="rounded-full border border-line px-6 py-3 text-[15px] font-semibold text-ink hover:text-primary" data-id="element-646" data-mp="1nxju2rsmry1p">
          Pijnklachten
        </Link>
      </div>
    </section>;
}